import { useState } from "react";

const faqs = [
  {
    question: "La poignée tourne dans le vide, est-ce grave ?",
    answer: "Ce n'est pas grave, mais c'est un signe que le mécanisme ne fonctionne plus. La poignée tourne dans le vide quand le carré d'entraînement est cassé ou quand la crémone est déconnectée. Dans les deux cas, la fenêtre ne ferme plus correctement, ce qui crée une faille d'étanchéité. Le mieux est d'appeler un technicien rapidement pour identifier la pièce à remplacer. Nous intervenons dans le Bas-Rhin sous 24h, diagnostic et déplacement gratuits.",
  },
  {
    question: "Faut-il changer la crémone aussi quand la poignée est cassée ?",
    answer: "Pas forcément. Si la poignée est cassée mais que la crémone est en bon état, nous remplaçons uniquement la poignée. Nous testons la crémone après avoir changé la poignée : si elle tourne bien, si les points de serrage se déclenchent correctement, et si la fenêtre ferme bien. Si la crémone est usée aussi, nous vous proposons le changement des deux. Le diagnostic est gratuit et fait sur place.",
  },
  {
    question: "Quel est le délai pour remplacer une poignée de fenêtre ?",
    answer: "Le remplacement d'une poignée de fenêtre prend entre 30 minutes et 1 heure, selon la complexité. Si nous avons la pièce en stock, nous intervenons le jour même à Strasbourg, Schiltigheim et Illkirch. Pour les autres communes du Bas-Rhin, l'intervention se fait sous 24h à 48h. Si la pièce doit être commandée (modèle rare ou ancien), le délai est de 2 à 4 jours. Nous vous prévenons à l'avance.",
  },
  {
    question: "Le prix du remplacement de poignée est-il inclus dans le devis gratuit ?",
    answer: "Oui, le diagnostic et le devis sont entièrement gratuits. Le déplacement dans tout le Bas-Rhin est aussi offert. Le prix du remplacement dépend de la marque et du modèle de la poignée : les poignées courantes sont moins chères que les modèles anciens ou spécifiques. La pièce de remplacement et la main-d'œuvre sont incluses dans le devis. Nous vous donnons le prix exact avant de commencer. Pas de frais cachés.",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-rose-50 py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-[1280px] mx-auto mx-auto">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Questions fréquentes
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum mb-8 leading-tight">
            FAQ — Poignée de <span className="font-serif italic">fenêtre</span>
          </h2>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div key={i} className="bg-white rounded-2xl border border-rose-200 overflow-hidden">
                <button
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left"
                  onClick={() => setOpenIndex(openIndex === i ? null : i)}
                >
                  <span className="font-semibold text-plum text-sm md:text-base pr-4">{faq.question}</span>
                  <div className={`w-8 h-8 rounded-full bg-rose-50 flex items-center justify-center shrink-0 transition-transform ${openIndex === i ? "rotate-180" : ""}`}>
                    <i className="ri-arrow-down-s-line text-plum" />
                  </div>
                </button>
                {openIndex === i && (
                  <div className="px-5 md:px-6 pb-5 md:pb-6">
                    <p className="text-plum-dark text-sm md:text-base leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}